<template>
<div>
  <div>
    <b-jumbotron
      header="Configurations"
      lead="Application Settings"
      id="last-version-jumbo">
    </b-jumbotron>
</div>

    <wtForm>
      <template slot="left" >



      </template>

      <template slot="right">
      </template>
    </wtForm>
  </div>
</template>
<script>

export default {
  name: "NotificationsContainer",
  components: { },
  data: function() {
    return {};
  },
  methods: {},
  created() {
    this.$store.commit("setTypeLayout", 2);
  },
};
</script>

